import {
  getElementLink,
  isElementContained,
} from './utils/dom-utils';
import { getCookie } from './utils/cookie-utils';
import {
  getEventData,
  siteEventNames,
} from './events/site-events';
import { getParameterByName } from './utils/url-utils';
import {
  triggerCustomGAEvent,
  triggerCustomGA4Event,
} from './utils/data-layer-utils';
import stringToHash from './utils/string-to-hash-util';
/*
  ===========================================================================================================================
  Status  Tag Name                                      GA4 Event Name              Logic
  ---------------------------------------------------------------------------------------------------------------------------
  [x]     Product Page View                             view_item                     Window Load
  [x]     Request Consultation Form Submit              request_consultation          Custom Event
  [x]     Page View                                     page_view                     Window Load
  [x]     Find an Expert Page View                      find_expert_view              Window Load
  [x]     Zip Code Search                               zipcode_search                Custom Event
  [x]     Swatch Page View                              swatch_pageview               Window Load
  [x]     Add Swatch                                    add_swatch                    Custom Event
  [x]     Place Swatch Order                            swatch_shipping               Custom Event
  [x]     Swatch Order Confirmation                     swatch_order                  Custom Event
  [x]     Dealer - Phone Number Click                   dealer_phone_click            Custom Event
  [x]     Dealer - Website Click                        dealer_website_click          Custom Event
  [x]     Troubleshooting - Document Click              troubleshooting_doc_click     Document 'click' Event Listener
  [x]     Visualization Page View                       visualization_view            Window Load
  [x]     Newsletter Signup                             newsletter_signup             Document 'click' Event Listener
  [x]     Login                                         login                         Custom Event
  [x]     Create Account                                sign_up                       Custom Event
  [x]     Product Page Tab Click                        product_page_tab_select       Document 'click' Event Listener
  [x]     Navigation Clicks                             navigation_clicks             Document 'click' Event Listener
  ===========================================================================================================================
*/
const { pageData } = window;
const {
  name,
  parentName,
  type,
} = pageData;

const addEventListeners = () => {
  /*
    ----------------------------------------
    GA4 Event Name: Login
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.ON_LOGGED_IN, () => {
    triggerCustomGA4Event({
      event: 'login',
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    ----------------------------------------
    GA4 Event Name: Create Account
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.ON_ACCOUNT_CREATED, () => {
    const data = getEventData(siteEventNames.ON_ACCOUNT_CREATED);
    triggerCustomGA4Event({
      event: 'sign_up',
      eventModel: {
        email_subscribe: data.optin,
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    -------------------------------------------------
    GA4 Event Name: Dealer - Phone Number Click
    Legacy GA Event Name: Dealer - Phone Number Click
    -------------------------------------------------
  */
  window.addEventListener(siteEventNames.DEALER_PHONE_CLICK, () => {
    const data = getEventData(siteEventNames.DEALER_PHONE_CLICK);
    const {
      dealer,
      phone,
    } = data;
    triggerCustomGAEvent({
      category: 'Dealer Locator Result',
      action: 'dealer-phone-click',
      label: `${dealer},${phone}`,
      value: '',
    });
    triggerCustomGA4Event({
      event: 'dealer_phone_click',
      eventModel: {
        dealer,
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    -------------------------------------------------
    GA4 Event Name: Dealer - Website Click
    -------------------------------------------------
  */
  window.addEventListener(siteEventNames.DEALER_WEBSITE_CLICK, () => {
    const eventModel = getEventData(siteEventNames.DEALER_WEBSITE_CLICK);
    triggerCustomGA4Event({
      event: 'dealer_website_click',
      eventModel,
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    ----------------------------------------
    GA4 Event Name: Dealer - Zip Code Search
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.ON_DEALER_SEARCH, () => {
    const eventModel = getEventData(siteEventNames.ON_DEALER_SEARCH);
    triggerCustomGA4Event({
      event: 'zipcode_search',
      eventModel,
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    ----------------------------------------
    GA4 Event Name: Dealer - Add Swatch
    ----------------------------------------
  */
  window.addEventListener(siteEventNames.ADD_SWATCH, () => {
    // const eventModel = getEventData(siteEventNames.ADD_SWATCH);
    const swatch = getEventData(siteEventNames.ADD_SWATCH);
    triggerCustomGA4Event({
      event: 'add_swatch',
      // eventModel,
      ecommerce: {
        items: [
          swatch,
        ],
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    -------------------------------------------------
    GA4 Event Name: Dealer - Place Swatch Order
    Legacy GA Event Name: Dealer - Place Swatch Order
    -------------------------------------------------
  */
  window.addEventListener(siteEventNames.ON_ORDER_SUBMITTED, () => {
    const data = getEventData(siteEventNames.ON_ORDER_SUBMITTED);
    const {
      action,
      category,
      label,
      optin,
      requestConsultation,
      swatches,
      value,
    } = data;
    triggerCustomGAEvent({
      action,
      category,
      label,
      value,
    });
    triggerCustomGA4Event({
      ecommerce: {
        items: swatches,
      },
      event: 'swatch_shipping',
      eventModel: {
        design_consultation_request: requestConsultation,
        email_subscribe: optin,
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    --------------------------------------------------
    GA4 Event Name: Dealer - Swatch Order Confirmation
    --------------------------------------------------
  */
  window.addEventListener(siteEventNames.ON_ORDER_CONFIRMATION, () => {
    const data = getEventData(siteEventNames.ON_ORDER_CONFIRMATION);
    const {
      orderNumber,
      swatches,
    } = data;
    triggerCustomGA4Event({
      ecommerce: {
        items: swatches,
      },
      event: 'swatch_order',
      eventModel: {
        swatch_order_number: orderNumber,
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    ----------------------------------------------------------------
    GA4 Event Name: Dealer - Request Consultation Form Submit
    ----------------------------------------------------------------
  */
  window.addEventListener(siteEventNames.ON_FORM_SUBMIT_SUCCESS, () => {
    const data = getEventData(siteEventNames.ON_FORM_SUBMIT_SUCCESS);
    const { optin } = data;
    triggerCustomGA4Event({
      ecommerce: {
        currency: 'USD',
        value: 60,
      },
      event: 'request_consultation',
      eventModel: {
        email_subscribe: optin,
        ...(parentName !== 'Graber Blinds' && { product_category: parentName }),
        ...(name !== 'Find An Expert' && { product_name: name }),
      },
      pageModel: {
        page_type: type,
      },
    });
  });
  /*
    ----------------------------------------
    GA4 Event Names:
    - Navigation Clicks
    - Product Page Tab Click
    - Newsletter Signup
    - Troubleshooting - Document Click
    ----------------------------------------
  */
  document.addEventListener('click', (event) => {
    const element = getElementLink(event.target);
    // Check if link is part of <header>, <footer>, or breadcrumbs nav
    const selectorList = [
      {
        label: 'Header',
        selector: 'header',
      },
      {
        label: 'Footer',
        selector: 'footer',
      },
      {
        label: 'Breadcrumb',
        selector: '.breadcrumbs',
      },
    ];
    selectorList.forEach((item) => {
      const {
        label,
        selector,
      } = item;
      const isMatch = isElementContained(event.target, selector);
      if (isMatch && element) {
        triggerCustomGA4Event({
          event: 'navigation_clicks',
          eventModel: {
            link_url: element.href,
            nav_location: label,
            nav_name: element.innerText,
            // product_name: '',
          },
          pageModel: {
            page_type: type,
          },
        });
      }
    });
    // Check if ancestor is part of tabbed navigation
    let selector = '.solutions-tabbed-content .tabnav';
    let isMatch = isElementContained(event.target, selector);
    if (isMatch) {
      const tab = event.target;
      triggerCustomGA4Event({
        event: 'product_page_tab_select',
        eventModel: {
          category_name: parentName,
          product_name: name,
          tab_name: tab.innerText,
        },
        pageModel: {
          page_type: type,
        },
      });
    }
    // Check if ancestor is w/in documents tabbed content container
    selector = '.tabbed-documents-wrapper .c-tabContent';
    isMatch = isElementContained(event.target, selector);
    if (isMatch) {
      triggerCustomGA4Event({
        event: 'troubleshooting_doc_click',
        eventModel: {
          support_doc_name: element.innerText,
        },
        pageModel: {
          page_type: type,
        },
      });
    }
  });
};

const addGA4PageLoadEvents = () => {
  /*
    ----------------------------------------
    GA4 Event Name: Page View
    ----------------------------------------
  */
  triggerCustomGA4Event({
    event: 'page_view',
    pageModel: {
      page_type: type,
    },
  });
  /*
    ----------------------------------------
    GA4 Event Name: Find an Expert Page View
    ----------------------------------------
  */
  if (type === 'FindAnExpertPage') {
    triggerCustomGA4Event({
      event: 'find_expert_view',
      pageModel: {
        page_type: type,
      },
    });
  }
  /*
    ----------------------------------------
    GA4 Event Name: Swatches Page View
    ----------------------------------------
  */
  if (type === 'SwatchPage') {
    triggerCustomGA4Event({
      event: 'swatch_pageview',
      eventModel: {
        product_id: getParameterByName('product'),
      },
      pageModel: {
        page_type: type,
      },
    });
  }
  /*
    ----------------------------------------
    GA4 Event Name: Visualization Page View
    ----------------------------------------
  */
  if (name === 'Visualizer') {
    triggerCustomGA4Event({
      event: 'visualization_view',
      eventModel: {
        // Hard-coded name because page type is 'GenericPage'
        // product_name: '',
        visualization_model: getParameterByName('Model'),
        visualization_prog_fam_name: getParameterByName('ProgramFamilyName'),
      },
      pageModel: {
        page_type: 'VisualizationPage',
      },
    });
  }
  /*
    ----------------------------------------
    GA4 Event Name: Product Page View
    ----------------------------------------
  */
  if (type === 'ProductLinePage') {
    triggerCustomGA4Event({
      event: 'view_item',
      eventModel: {
        category_name: parentName,
        product_name: name,
      },
      pageModel: {
        page_type: type,
      },
    });
  }
};

const init = () => {
  // Declare dataLayer array for session vars and GTM container
  window.dataLayer = [];
  let data = {};
  const storageKey = '_datalayer';
  const {
    netSessionId,
    sessionStorage,
  } = window;
  const isSessionData = sessionStorage.getItem(storageKey);
  if (!isSessionData) {
    data = {
      isGraberDealer: getCookie('isGraberDealer'),
      userID: netSessionId,
      utmSource: getParameterByName('utm_source'),
      utmMedium: getParameterByName('utm_medium'),
      utmCampaign: getParameterByName('utm_campaign'),
      utmContent: getParameterByName('utm_content'),
      utmTerm: getParameterByName('utm_term'),
    };
    sessionStorage.setItem(storageKey, JSON.stringify(data));
  } else {
    data = JSON.parse(sessionStorage.getItem(storageKey));
  }
  const dataLayerObj = {
    isGraberDealer: data.isGraberDealer,
    email: sessionStorage.getItem('email'),
    userID: data.userID,
    utmSource: data.utmSource,
    utmMedium: data.utmMedium,
    utmCampaign: data.utmCampaign,
    utmContent: data.utmContent,
    utmTerm: data.utmTerm,
  };
  const email = sessionStorage.getItem('email');
  if (email) {
    stringToHash(email)
      .then((hash) => {
        if (hash) {
          dataLayerObj.email = hash.replace(/"/g, '');
          window.dataLayer.push(dataLayerObj);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  } else {
    window.dataLayer.push(dataLayerObj);
  }
};

init();
window.getParameterByName = getParameterByName;
window.dataLayerApi = {
  config: () => {
    addGA4PageLoadEvents();
    addEventListeners();
  },
};
